var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box is-centered wrapper-data-receiver" }, [
    _c("h1", { staticClass: "title has-text-primary title-data-receiver" }, [
      _vm._v("\n    Información\n  ")
    ]),
    _c(
      "div",
      { staticClass: "columns is-multiline" },
      [
        !_vm.isTradeTransfer
          ? _c(
              "div",
              {
                staticClass: "column",
                class: { "is-6": !_vm.inline, "is-4": _vm.inline }
              },
              [
                _c(
                  "BField",
                  { attrs: { label: "RFC", "label-for": "customerRFC" } },
                  [
                    _c("BInput", {
                      attrs: {
                        id: "customerRFC",
                        name: "rfc",
                        disabled: _vm.isLoading || _vm.disabled,
                        value: _vm.$store.state.invoice.receiverRfc,
                        pattern: _vm.pattern,
                        required: "",
                        maxlength: "13"
                      },
                      on: {
                        input: function($event) {
                          return _vm.onChange("receiverRfc", $event)
                        },
                        change: function($event) {
                          return _vm.onChange("receiverRfc", $event)
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "column",
            class: { "is-6": !_vm.inline, "is-4": _vm.inline }
          },
          [
            _c(
              "BField",
              {
                attrs: {
                  label: "Razón social",
                  "label-for": "customerCompanyName"
                }
              },
              [
                _c("BInput", {
                  attrs: {
                    id: "customerCompanyName",
                    name: "companyName",
                    disabled: _vm.isLoading || _vm.disabled,
                    value: _vm.$store.state.customers.companyName,
                    required: ""
                  },
                  on: {
                    input: function($event) {
                      return _vm.onChange("receiverName", $event)
                    },
                    change: function($event) {
                      return _vm.onChange("receiverName", $event)
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "column",
            class: { "is-6": !_vm.inline, "is-4": _vm.inline }
          },
          [
            _c(
              "BField",
              { attrs: { label: "Email", "label-for": "customerEmail" } },
              [
                _c("BInput", {
                  attrs: {
                    id: "customerEmail",
                    name: "email",
                    type: "email",
                    disabled: _vm.isLoading || _vm.disabled,
                    value: _vm.$store.state.customers.email,
                    required: ""
                  },
                  on: {
                    input: function($event) {
                      return _vm.onChange("operation.email", $event)
                    },
                    change: function($event) {
                      return _vm.onChange("operation.email", $event)
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "column",
            class: { "is-6": !_vm.inline, "is-4": _vm.inline }
          },
          [
            _c(
              "BField",
              { attrs: { label: "Nombre", "label-for": "customerName" } },
              [
                _c("BInput", {
                  attrs: {
                    id: "customerName",
                    name: "name",
                    disabled: _vm.isLoading || _vm.disabled,
                    value: _vm.$store.state.customers.name,
                    required: ""
                  },
                  on: {
                    input: function($event) {
                      return _vm.onChange("operation.name", $event)
                    },
                    change: function($event) {
                      return _vm.onChange("operation.name", $event)
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "column",
            class: { "is-6": !_vm.inline, "is-4": _vm.inline }
          },
          [
            _c(
              "BField",
              {
                attrs: { label: "Código postal", "label-for": "privateZipCode" }
              },
              [
                _c("BInput", {
                  attrs: {
                    id: "privateZipCode",
                    value: _vm.$store.state.customers.zipCode,
                    placeholder: "00000",
                    icon: "account-card-details",
                    pattern: _vm.zipCodePattern,
                    disabled: _vm.disabled,
                    loading: _vm.isLoading,
                    required: ""
                  },
                  on: {
                    input: function($event) {
                      return _vm.onInput("zipCode", $event)
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "column",
            class: { "is-6": !_vm.inline, "is-4": _vm.inline }
          },
          [
            _c("AppSelectSearch", {
              attrs: {
                id: "privateTaxRegime",
                name: "privateTaxRegime",
                label: "Régimen fiscal",
                icon: "domain",
                options: _vm.taxRegimeCatalog,
                value: _vm.taxRegimeSelected(),
                required: ""
              },
              on: {
                input: function($event) {
                  return _vm.onInput("taxRegime", $event.target.value)
                },
                change: function($event) {
                  return _vm.onInput("taxRegime", $event.target.value)
                }
              }
            })
          ],
          1
        ),
        !_vm.isTradeTransfer
          ? _c("div", { staticClass: "column is-12 is-centered" }, [
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [
                  _vm._v("\n          ¿Eres extranjero?\n        ")
                ]),
                _c("div", { staticClass: "control is-flex is-centered" }, [
                  _c("div", { staticClass: "field has-addons" }, [
                    _c("p", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button",
                          class: {
                            "is-success": _vm.isForeign,
                            "is-loading": _vm.isLoading
                          },
                          attrs: { disabled: _vm.disabled },
                          on: {
                            click: function($event) {
                              return _vm.onChangeForeign(true)
                            }
                          }
                        },
                        [_c("span", [_vm._v("Sí")])]
                      )
                    ]),
                    _c("p", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button",
                          class: {
                            "is-success": !_vm.isForeign,
                            "is-loading": _vm.isLoading
                          },
                          attrs: { disabled: _vm.disabled },
                          on: {
                            click: function($event) {
                              return _vm.onChangeForeign(false)
                            }
                          }
                        },
                        [_c("span", [_vm._v("No")])]
                      )
                    ])
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm.isForeign
          ? [
              _c(
                "div",
                {
                  staticClass: "column",
                  class: { "is-12": !_vm.inline, "is-4": _vm.inline }
                },
                [
                  _c("AppSelectSearch", {
                    attrs: {
                      id: "receiverFiscalResidence",
                      name: "receiverFiscalResidence",
                      label: "Residencia fiscal",
                      placeholder: "Residencia Fiscal",
                      value: _vm.countrySelected,
                      options: _vm.countryCatalog,
                      "is-loading": _vm.isLoading,
                      required: true
                    },
                    on: {
                      input: _vm.onChangeSelection,
                      change: _vm.onChangeSelection
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "column",
                  class: { "is-12": !_vm.inline, "is-4": _vm.inline }
                },
                [
                  _c("AppInputField", {
                    attrs: {
                      id: "numRegIdTrib",
                      name: "receiverNumRegIdTrib",
                      label: "Número de registro identificación tributaria ",
                      placeholder:
                        "Número de registro identificación tributaria ",
                      value: _vm.receiverNumRegIdTrib,
                      disabled: _vm.disabled,
                      "is-loading": _vm.isLoading
                    },
                    on: {
                      input: function($event) {
                        return _vm.onChange(
                          "receiverNumRegIdTrib",
                          $event.target.value
                        )
                      },
                      change: function($event) {
                        return _vm.onChange(
                          "receiverNumRegIdTrib",
                          $event.target.value
                        )
                      }
                    }
                  })
                ],
                1
              )
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }